"use client";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";

import { css } from "@/../styled-system/css";
import LoaderCircle from "@/assets/svg/loader-circle.svg";
import Input from "@/components/ui/Input";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  ReactForm,
} from "@/components/ui/ReactForm";
import { TContactFormSchema, contactFormSchema } from "@/types/zod/types";

import Button from "../ui/Button";
import { Checkbox } from "../ui/Checkbox";
import PhoneInput from "../ui/PhoneInput";
import Textarea from "../ui/Textarea";
import { toast } from "../ui/UseToast";

export default function MailFormNoAction() {
  //   const [state, formAction] = useFormState(submitContactForm, {
  //     message: "",
  //   });
  // const { pending } = useFormStatus();
  const form = useForm<TContactFormSchema>({
    resolver: zodResolver(contactFormSchema),
    defaultValues: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      message: "",
      privacyPolicy: false,
    },
  });

  const {
    control,
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = form;

  // Effect to show toast when state.message is updated
  //   useEffect(() => {
  //     if (state?.message === "Message sent successfully") {
  //       toast({
  //         title: "Success",
  //         description: state.message,
  //       });
  //       reset();
  //     } else {
  //       toast({
  //         title: "Error",
  //         description: state.message,
  //         variant: "destructive",
  //       });
  //     }
  //   }, [reset, state.message]);

  // // console.log("is pending", pending);
  const onSubmitForm = async (data: TContactFormSchema) => {
    const response = await fetch("/api/contact-test", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const responseData = await response.json();

    if (!responseData.ok) {
      toast({
        title: "Success",
        description: "Message sent successfully",
      });
      reset();
    } else {
      toast({
        title: "Error",
        description: "Message failed to send",
        variant: "destructive",
      });
    }
  };
  return (
    <ReactForm {...form}>
      {/* {state?.message !== "" && !state.issues && (
        <div className="text-red-500">{state.message}</div>
      )} */}
      {/* {state?.issues && (
        <div className="text-red-500">
          <ul>
            {state.issues.map((issue: any) => (
              <li key={issue} className="flex gap-1">
                {issue}
              </li>
            ))}
          </ul>
        </div>
      )} */}
      <form
        className={css({
          display: "flex",
          flexDirection: "column",
          gap: "6",
          maxWidth: "480px",
          mx: "auto",
        })}
        onSubmit={handleSubmit(onSubmitForm)}
      >
        <div className={css({ sm: { display: "flex", gap: "8" } })}>
          <FormField
            control={control}
            name="firstName"
            render={({ field }) => (
              <FormItem css={{ mb: "8", sm: { mb: "unset" } }}>
                <FormLabel>First Name</FormLabel>
                <FormControl>
                  <Input
                    disabled={isSubmitting}
                    placeholder="First Name"
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={control}
            name="lastName"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Last Name</FormLabel>
                <FormControl>
                  <Input
                    disabled={isSubmitting}
                    placeholder="Last Name"
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <FormField
          control={control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Email</FormLabel>
              <FormControl>
                <Input
                  disabled={isSubmitting}
                  type="email"
                  placeholder="e.g. stephenking@lorem.com"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="phoneNumber"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Phone Number</FormLabel>
              <FormControl>
                <PhoneInput
                  disabled={isSubmitting}
                  placeholder="e.g. +1 234 567 890"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="message"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Message</FormLabel>
              <FormControl>
                <Textarea
                  disabled={isSubmitting}
                  placeholder="Message"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="privacyPolicy"
          render={({ field }) => (
            <FormItem
              css={{ flexDirection: "row", alignItems: "center", gap: "4" }}
            >
              <FormControl>
                <Checkbox
                  disabled={isSubmitting}
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
              <FormLabel>You agree to our friendly privacy policy.</FormLabel>
              {/* <FormMessage /> */}
            </FormItem>
          )}
        />
        <Button
          disabled={isSubmitting}
          type="submit"
          width="fill"
          variant="brandBlue"
        >
          {isSubmitting && (
            <LoaderCircle width={20} className={css({ animation: "spin" })} />
          )}
          <span>Submit</span>
        </Button>
        {/* <Submit /> */}
      </form>
    </ReactForm>
  );
}
